import { type TooltipProps as TooltipPropsMUI, Tooltip as TooltipMUI, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export type TooltipProps = {
    children?: JSX.Element | string
} & TooltipPropsMUI

const Tooltip = (props: TooltipProps): JSX.Element => <TooltipMUI {...props} />;

export const SecondaryTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))`
    .${tooltipClasses.arrow}::before {
        background-color: #10334bf8;
    }

    .${tooltipClasses.tooltip} {
        padding: 10px 15px;
        background: #10334bf8;
        color: white;
        box-shadow: 0 10px 36px 0 #eeeff1cc;
    }

`;

export default Tooltip;
